import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import {getCurrentYear} from "../Common/YearChooser";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import i18next from "i18next";

class AccessMatrix extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            currentYear: getCurrentYear(),
            inOperation: true
        }
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            let key = {};
            await this.props.dispatch(this.props.ComMonTune_ListWSForPO.execute(key));
            await this.props.dispatch(this.props.ComMonTune_ListAddWSForPO.execute(key));
        } catch (e) {
            console.error(e);
        } finally {
            this.setState({inOperation: false});
        }
    }


    render() {

        const style = Object.assign({
            backgroundColor: "#fff",
            cursor: "pointer",
            ':active': {color: "#495057", borderColor: "#dee2e6 #dee2e6 #fff"}
        });
        return (
            <PlaceholderWrapper placeholderId="10" showSplitterLine={false} canCollapse={false} showInstruction={false}>
                <ul className="nav nav-tabs" role="tablist" id="nav-tab">
                    <li className="nav-item" key="ListWSForPO">
                        <a id="ListWSForPO-tab" data-toggle="tab" href="#ListWSForPO" className="nav-link active"
                           style={style} role="tab"
                           aria-controls="ListWSForPO" aria-selected="true">{i18next.t("AvailableWorkingPlaces")}</a>
                    </li>
                    <li className="nav-item" key="ListAddWSForPO">
                        <a id="ListAddWSForPO-tab" data-toggle="tab" href="#ListAddWSForPO" className="nav-link"
                           style={style} role="tab"
                           aria-controls="ListAddWSForPO"
                           aria-selected="false">{i18next.t("AdditionalWorkingPlaces")}</a>
                    </li>
                </ul>
                <div className="tab-content">
                    <div id="ListWSForPO" className="tab-pane show active inwhite card" role="tabpanel"
                         aria-labelledby="ListWSForPO-tab">
                        <GridView dataItem={this.props.ComMonTune_ListWSForPO}/>
                    </div>
                    <div id="ListAddWSForPO" className="tab-pane inwhite card" role="tabpanel"
                         aria-labelledby="ListAddWSForPO-tab">
                        <GridView dataItem={this.props.ComMonTune_ListAddWSForPO}/>
                    </div>
                </div>
            </PlaceholderWrapper>
        )
    }
}

AccessMatrix.propTypes = {
    dispatch: PropTypes.func.isRequired,
    ComMonTune_ListWSForPO: PropTypes.object,
    ComMonTune_ListAddWSForPO: PropTypes.object
}

AccessMatrix.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        ComMonTune_ListWSForPO: state.accessMatrixState.ComMonTune_ListWSForPO,
        ComMonTune_ListAddWSForPO: state.accessMatrixState.ComMonTune_ListAddWSForPO
    }
}

export default connect(mapStateToProps)(AccessMatrix)